import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import getAnswers from '../../../helpers/content/manageContent/getAnswers'
import AnswerChoiceEditor from '../AnswerChoiceEditor'

class AnswerCards extends Component {
  render() {
    const { 
      activeItem,
      colorScheme,
      toggleActiveEditor,
      handleDeleteAnswerChoice,
      handleClickThumb,
      handleQuillChange,
      quillText,
      quillActiveItem,
      copyFeedback,
      handleClickSave,
      saving,
    } = this.props
    const {
      activeEdit,
      answers,
      shuffle,
      startingLetter, } = quillActiveItem
    const answersArray = getAnswers(activeItem)
    return (
      <div>
        {answersArray.map((answer, n) => 
            <Col xs='12' sm='12' md='12' lg='12' key={'answercard' + n}>
              <AnswerChoiceEditor 
                colorScheme={colorScheme}
                correctChoiceQ={quillActiveItem.answers[n] && quillActiveItem.answers[n].correct}
                cardIndex={n}
                activeEdit={activeEdit}
                answers={answers}
                toggleActiveEditor={toggleActiveEditor}
                handleDeleteAnswerChoice={handleDeleteAnswerChoice}
                handleClickThumb={handleClickThumb}
                shuffle={shuffle}
                startingLetter={startingLetter}
                handleQuillChange={handleQuillChange}
                quillText={quillText}
                copyFeedback={copyFeedback}
                handleClickSave={handleClickSave}
                saving={saving}
              />
            </Col>
        )}
      </div>
    )
  }
}

export default AnswerCards


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/AnswerCards.js